export default {
      id: "schedule-usage",
      viewBox: "0 0 17 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#schedule",
      toString: function () {
        return this.url;
      }
    }